var _defineProperty = require("/home/runner/work/scratchlinkcodes/scratchlinkcodes/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/defineProperty");

var _PROJECT_TYPES$CODING, _RemoteControlSumo, _PROJECT_TYPES$CODING2, _StayInRing, _PROJECT_TYPES$CODING3, _ScanCharge, _PROJECT_TYPES$CODING4, _SUMO;

var _require = require('../constants'),
    BLOCK_LEVEL_TYPES = _require.BLOCK_LEVEL_TYPES,
    PROJECT_TYPES = _require.PROJECT_TYPES;

var ScratchDemoRemoteControlSumoBeginnerProject = 'ScratchDemoRemoteControlSumoBeginnerProject';
var ScratchRemoteControlSumoBeginnerProject = 'ScratchRemoteControlSumoBeginnerProject';
var ScratchRemoteControlSumoCoreProject = 'ScratchRemoteControlSumoCoreProject';
var ScratchRemoteControlSumoAdvancedProject = 'ScratchRemoteControlSumoAdvancedProject';
var ScratchDemoStayInRingBeginnerProject = 'ScratchDemoStayInRingBeginnerProject';
var ScratchDemoScanAndChargeBeginnerProject = 'ScratchDemoScanAndChargeBeginnerProject';
var ScratchDemoSumoBeginnerProject = 'ScratchDemoSumoBeginnerProject';
var ScratchStayInRingBeginnerProject = 'ScratchStayInRingBeginnerProject';
var ScratchStayInRingCoreProject = 'ScratchStayInRingCoreProject';
var ScratchStayInRingAdvancedProject = 'ScratchStayInRingAdvancedProject';
var ScratchScanAndChargeBeginnerProject = 'ScratchScanAndChargeBeginnerProject';
var ScratchScanAndChargeCoreProject = 'ScratchScanAndChargeCoreProject';
var ScratchScanAndChargeAdvancedProject = 'ScratchScanAndChargeAdvancedProject';
var ScratchSumoBeginnerProject = 'ScratchSumoBeginnerProject';
var ScratchSumoCoreProject = 'ScratchSumoCoreProject';
var ScratchSumoAdvancedProject = 'ScratchSumoAdvancedProject';
var ScratchComingSoonProject = 'ScratchComingSoonProject';
var ScratchEbotEmptyProject = 'ScratchEbotEmptyProject';
module.exports = {
  'Remote Control Sumo': (_RemoteControlSumo = {}, _defineProperty(_RemoteControlSumo, PROJECT_TYPES.DEMO, _defineProperty({}, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchDemoRemoteControlSumoBeginnerProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  })), _defineProperty(_RemoteControlSumo, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING = {}, _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchRemoteControlSumoBeginnerProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchRemoteControlSumoCoreProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING, BLOCK_LEVEL_TYPES.ADVANCED, {
    scratch: {
      scratchProject: ScratchRemoteControlSumoAdvancedProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _PROJECT_TYPES$CODING)), _RemoteControlSumo),
  'Stay in Ring': (_StayInRing = {}, _defineProperty(_StayInRing, PROJECT_TYPES.DEMO, _defineProperty({}, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchDemoStayInRingBeginnerProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  })), _defineProperty(_StayInRing, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING2 = {}, _defineProperty(_PROJECT_TYPES$CODING2, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchStayInRingBeginnerProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING2, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchStayInRingCoreProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING2, BLOCK_LEVEL_TYPES.ADVANCED, {
    scratch: {
      scratchProject: ScratchStayInRingAdvancedProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _PROJECT_TYPES$CODING2)), _StayInRing),
  'Scan & Charge': (_ScanCharge = {}, _defineProperty(_ScanCharge, PROJECT_TYPES.DEMO, _defineProperty({}, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchDemoScanAndChargeBeginnerProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  })), _defineProperty(_ScanCharge, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING3 = {}, _defineProperty(_PROJECT_TYPES$CODING3, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchScanAndChargeBeginnerProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING3, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchScanAndChargeCoreProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING3, BLOCK_LEVEL_TYPES.ADVANCED, {
    scratch: {
      scratchProject: ScratchScanAndChargeAdvancedProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _PROJECT_TYPES$CODING3)), _ScanCharge),
  'SUMO': (_SUMO = {}, _defineProperty(_SUMO, PROJECT_TYPES.DEMO, _defineProperty({}, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchDemoSumoBeginnerProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  })), _defineProperty(_SUMO, PROJECT_TYPES.CODINGPROJECT, (_PROJECT_TYPES$CODING4 = {}, _defineProperty(_PROJECT_TYPES$CODING4, BLOCK_LEVEL_TYPES.BEGINNER, {
    scratch: {
      scratchProject: ScratchSumoBeginnerProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING4, BLOCK_LEVEL_TYPES.CORE, {
    scratch: {
      scratchProject: ScratchSumoCoreProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _defineProperty(_PROJECT_TYPES$CODING4, BLOCK_LEVEL_TYPES.ADVANCED, {
    scratch: {
      scratchProject: ScratchSumoAdvancedProject,
      projectVideoId: 'dv6etKxr',
      projectResourcesLink: 'https://google.com',
      projectInfo: 'Some help info here'
    }
  }), _PROJECT_TYPES$CODING4)), _SUMO)
};